import React, { useEffect, useRef, useState } from "react";
import { BiImageAdd } from "react-icons/bi";
import CategoryService from "../../services/category.service";
import * as yup from "yup";
import { notifyError, notifySuccess } from "../../hook/notification";
import useDialogState, { Loader } from "../../hook";
import { useFormik } from "formik";
import MultiImageService from "../../services/multiimage.service";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import NotificationService from "../../services/notification.service";
import CollectionService from "../../services/collection.service";

// Custom Dropdown component
const Dropdown = ({ options, onSelect, selectedValue }) => {
  const menuRef = useRef();
  const [toggleShow, setToggleShow] = useState(false);

  const userToggle = () => {
    setToggleShow((prev) => !prev);
  };

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="flex flex-col gap-2 relative">
      <div onClick={userToggle} className="input cursor-pointer">
        {selectedValue === "" ? "Select" : selectedValue}
      </div>
      <div
        className={`${
          toggleShow ? "block" : "hidden"
        } bg-gray-800 rounded-6 overflow-hidden absolute top-[40px] w-full z-70 min-h-10 max-h-52 h-auto overflow-y-auto`}
      >
        {options.length > 0 ? (
          options.map((option, index) => (
            <p
              key={index}
              onClick={() => {
                onSelect(option.label, option.value);
                setToggleShow(false);
              }}
              className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white"
            >
              {option.label}
            </p>
          ))
        ) : (
          <p className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white">
            No data found
          </p>
        )}
      </div>
    </div>
  );
};

const AddMultiImages = () => {
  const menuRef = useRef();
  const navigate = useNavigate();
  const hiddenFileInput = useRef(null);
  const [data, setData] = useState([]);
  const [showVal, setShowVal] = useState("GIF");
  const [showVal2, setShowVal2] = useState("NON PREMIUM");
  const [showVal3, setShowVal3] = useState("");
  const [showVal4, setShowVal4] = useState("");
  const [fileName, setFileName] = useState([]);
  const [notification, setNotification] = useState(false);
  const [collectionData, setCollectionData] = useState([]);

  const sendNotification = (e) => {
    setNotification(e.target.checked);
  };

  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const handleSelect = (value, id) => {
    formik.setFieldValue("multimediaType", id);
    setShowVal(value);
  };

  const handleSelect2 = (value, id) => {
    formik.setFieldValue("premium", id === "PREMIUM" ? true : false);
    setShowVal2(value);
  };

  const handleSelect3 = (value, id) => {
    formik.setFieldValue("categoryId", id);
    setShowVal3(value);
  };

  const handleSelect4 = (value, id) => {
    formik.setFieldValue("collectionId", id);
    setShowVal4(value);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    const fileUploaded = Array.from(event.target.files);
    formik.setFieldValue("images", fileUploaded);
    setFileName(fileUploaded);
  };

  const MultiMediaType = [
    { value: "IMAGE", label: "IMAGE" },
    { value: "VIDEO", label: "VIDEO" },
    { value: "GIF", label: "GIF" },
  ];

  const ImageType = [
    { value: "PREMIUM", label: "PREMIUM" },
    { value: "NON PREMIUM", label: "NON PREMIUM" },
  ];

  const getAllData = async () => {
    const response = await CategoryService.GetAllCategory(0, 0);
    const data = response.data.apiresponse.data;
    setData(data.categories);
  };

  const getAllCollectionData = async () => {
    const response = await CollectionService.GetAllCollection(0, 0);
    const data = response.data.apiresponse.data;
    setCollectionData(data?.collections);
  };

  useEffect(() => {
    getAllData();
    getAllCollectionData();
  }, []);

  const CategoryOption = data.map((item) => {
    return {
      label: item.categoryName,
      value: item.id,
    };
  });

  const CollectionOption = collectionData.map((item) => {
    return {
      label: item.collectionName,
      value: item.id,
    };
  });

  const schema = yup.object().shape({
    imageName: yup.string().required("Please enter name"),
    images: yup
      .array()
      .of(yup.string().required("Please select image type"))
      .min(1),
    premium: yup.boolean().required("Please select image type"),
    // categoryId: yup.string().required("Please select image category"),
  });

  const initialValue = {
    categoryId: "",
    imageName: "",
    images: [],
    premium: false,
    collectionId: "",
  };

  const submit = async (values, action) => {
    const { categoryId, imageName, images, premium, collectionId } = values;
    try {
      const fileData = new FormData();
      fileData.append("categoryId", categoryId || 0);
      fileData.append("imageName", imageName);
      fileName.forEach((item) => {
        fileData.append(`images`, item);
      });
      fileData.append("premium", premium);
      fileData.append("collectionId", collectionId || 0);
      fileData.append("sendNotification", notification);
      setLoader();
      await MultiImageService.createMultiImage(fileData);
      // if (notification) {
      //   await NotificationService.sendNotification(notification);
      // }
      notifySuccess("Add multiple image successfully");
      setTimeout(() => {
        setFileName("");
        unSetLoader();
        navigate("/images");
        action.resetForm();
      }, 1500);
    } catch (error) {
      console.error("create race error", error);
      notifyError("Something went wrong");
      setTimeout(() => {
        setFileName("");
        unSetLoader();
        navigate("/images");
        action.resetForm();
      }, 1500);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  console.log("formik", formik);
  return (
    <>
      <div
        className="max-w-[900px] min-w-[300px] w-auto px-5 pb-10"
        ref={menuRef}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="py-10">
            <h1 className="text-base font-semibold leading-7 text-white">
              Insert Multiple Images
            </h1>
            <p className="text-sm text-gray-500">Upload Images in Bulk</p>
          </div>
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Name</label>
            <input
              className="input"
              name="imageName"
              placeholder="image name"
              value={formik.values.imageName}
              onChange={formik.handleChange}
              type="text"
            />
            {formik.errors.imageName && formik.touched.imageName && (
              <div className="text-red text-sm">{formik.errors.imageName}</div>
            )}
          </div>

          {/* Second Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Type</label>
            <Dropdown
              options={ImageType}
              onSelect={(value, id) => handleSelect2(value, id)}
              selectedValue={showVal2}
            />
            {formik.errors.premium && formik.touched.premium && (
              <div className="text-red text-sm">{formik.errors.premium}</div>
            )}
          </div>

          {/* Thrird Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Category</label>
            <Dropdown
              options={CategoryOption}
              onSelect={(value, id) => handleSelect3(value, id)}
              selectedValue={showVal3}
            />
            {formik.errors.categoryId && formik.touched.categoryId && (
              <div className="text-red text-sm">{formik.errors.categoryId}</div>
            )}
          </div>

          {/* Fourth Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Collection</label>
            <Dropdown
              options={CollectionOption}
              onSelect={(value, id) => handleSelect4(value, id)}
              selectedValue={showVal4}
            />
            {formik.errors.collectionId && formik.touched.collectionId && (
              <div className="text-red text-sm">
                {formik.errors.collectionId}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2 mb-7">
            <div className="">
              <label className="label">List Of Layer Image</label>
              <div className="mt-4">
                <div className="flex items-center gap-5 mb-4">
                  <input type="image" accept="image/*" id="upload" hidden />
                  <label
                    onClick={handleClick}
                    className="border-2 border-dashed border-blue rounded-6 flex items-center gap-2 p-2 cursor-pointer max-w-96 w-full"
                  >
                    <BiImageAdd className="text-blue text-2xl" />
                    <span className="text-white text-sm  line-clamp-1 ">
                      {fileName.length === 0
                        ? "Upload or drop a file right here"
                        : fileName.length + " file uploaded"}
                    </span>
                  </label>
                  <input
                    type="file"
                    onChange={handleChange}
                    ref={hiddenFileInput}
                    accept="image/*"
                    className="hidden"
                    multiple
                  />
                </div>
                {console.log(formik.errors)}
                {formik.errors.images && formik.touched.images && (
                  <div className="text-red text-sm">{formik.errors.images}</div>
                )}
              </div>
            </div>
            <div className="flex gap-5 items-center pb-6"></div>
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="notificaiton"
              className="p-3"
              onChange={sendNotification}
            />
            <label
              htmlFor="notificaiton"
              className="text-white ps-4 cursor-pointer"
            >
              Send Notification
            </label>
          </div>
          <div className="flex justify-end gap-4 items-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn cancel"
            >
              Cancel
            </button>
            <button type="submit" className="btn save">
              {loader ? <Loader /> : "Save"}
            </button>
          </div>
        </form>
        <ToastContainer autoClose={1500} />
      </div>
    </>
  );
};

export default AddMultiImages;
